import { Icon } from '@/shared/ui/icon'
import { useStyles } from './styles'
import { AppButton } from '@/shared/ui/button'
import { $userLanguage } from '@/entities/user'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { TIconVariant } from '@/shared/ui/icon'
import { CaseSubNameText } from './subname'
import { goToCase } from '@/app/routing/events'
import { format } from 'date-fns'
import { Case } from '@/entities/cases'

const CaseCard = (props: Case) => {
  const {
    id,
    name: caseName,
    active: isAvailable,
    expired_at: expiredAt,
    description: boxDescription,
    price_keys: price,
    photo_url,
  } = props
  const parsedPlatform = boxDescription.replace(/ /g, '').toLowerCase()
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.boxPage
  const btnTexts = lang[userLang].pages.btnTexts
  return (
    <AppButton
      className={classes.root}
      data-isavailable={isAvailable}
      onClick={() => {
        goToCase({ id: id })
      }}
    >
      <Icon view="arrowRight" width={20} style={{ position: 'absolute', top: '10%', right: '2%' }} />
      <Icon
        view={parsedPlatform as TIconVariant}
        width={32}
        style={{ position: 'absolute', top: '5%', left: '2%', zIndex: 2 }}
      />
      <div className={classes.imageWrapper}>
        <img src={photo_url} alt="" className={classes.caseImage} />
      </div>
      <div className={classes.textAndButtonContainer}>
        <div className={classes.caseNameSubnameWrapper}>
          <span className={classes.caseTitle}>{texts.headings[caseName]}</span>
          <CaseSubNameText caseName={caseName} />
        </div>
        <div className={classes.buttonWrapper}>
          <div className={classes.openButton}>
            {isAvailable ? (
              <>
                {btnTexts.open}
                <Icon view="gamedKey" width={24} />
                {price}
              </>
            ) : (
              <>
                {texts.expired} {expiredAt ? format(new Date(expiredAt), 'dd.MM.yyyy') : 'XX.XX.XX'}
              </>
            )}
          </div>
        </div>
      </div>
    </AppButton>
  )
}

export default CaseCard
